import { render, staticRenderFns } from "./ViewCandidateProfile.vue?vue&type=template&id=126acebb&scoped=true"
import script from "./ViewCandidateProfile.vue?vue&type=script&lang=ts"
export * from "./ViewCandidateProfile.vue?vue&type=script&lang=ts"
import style0 from "./ViewCandidateProfile.vue?vue&type=style&index=0&id=126acebb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126acebb",
  null
  
)

export default component.exports